declare function matPreloader(type: 'on' | 'off'): void;
declare var Swal: any;

/**
 * SPA-like Dynamic Navigation System for mirecibo.watsontic.com
 * Handles seamless page loads without full-page reloads.
 */
var SPANavigation = class {
    private containerSelector = '#spa-contenido-container';

    constructor() {
        this.initEventListeners();
        this.highlightActiveMenu();
        this.startSmartSessionRefresh();
    }

    private initEventListeners(): void {
        const self = this;

        // Intercept all links that belong to the admin dashboard
        $(document).on('click', 'a', function (this: HTMLAnchorElement, e: JQuery.ClickEvent) {
            const href = $(this).attr('href');

            // Verify if the link is a valid dashboard path and not a direct file or logout action
            if (href && href.startsWith('/admin') && !href.includes('/logout') && !$(this).attr('target') && !$(this).attr('download')) {
                e.preventDefault();
                self.navigateTo(href);
            }
        });

        // Handle browser back/forward buttons
        $(window).on('popstate', () => {
            self.loadPage(window.location.pathname + window.location.search, false);
        });
    }

    /**
     * Navigates to a new URL and updates history
     */
    public navigateTo(url: string): void {
        // Prevent loading the exact same page
        if (url === window.location.pathname + window.location.search) {
            return;
        }
        this.loadPage(url, true);
    }

    private progressInterval: any = null;

    /**
     * Shows a beautiful fullscreen-like overlay loader on #kt_app_main
     */
    private showMainPreloader(): void {
        // Remove existing one if any
        $('#kt_app_main_preloader').remove();
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }

        const preloaderHtml = `
            <div id="kt_app_main_preloader" class="kt-app-main-preloader-container animate__animated animate__fadeIn">
                <div class="d-flex flex-column align-items-center text-center p-5">
                    <!-- Modern pulsing circles loader -->
                    <div class="loader-pulse-wrapper mb-6">
                        <div class="loader-pulse-ring"></div>
                        <div class="loader-pulse-ring"></div>
                        <div class="loader-pulse-ring"></div>
                        <div class="loader-pulse-icon">
                            <i class="fas fa-sync-alt text-white fs-4 fa-spin"></i>
                        </div>
                    </div>
                    
                    <h3 class="fw-bold text-gray-900 mb-2">Cargando...</h3>
                    <p class="text-muted fs-6 mb-6">Por favor, espere un momento mientras preparamos la sección</p>
                    
                    <!-- Progress bar -->
                    <div class="w-250px bg-light rounded-pill overflow-hidden position-relative mb-4" style="height: 6px; border: 1px solid rgba(0,0,0,0.05);">
                        <div id="preloader_bar_progress" class="bg-primary h-100 rounded-pill" style="width: 0%; transition: width 0.15s ease-out;"></div>
                    </div>
                    
                    <!-- Percentage counter -->
                    <span id="preloader_percentage" class="fw-bolder text-primary fs-3">0%</span>
                </div>
            </div>
        `;

        $('#kt_app_main').append(preloaderHtml);

        // Smoothly start progress simulation
        let currentProgress = 0;
        this.progressInterval = setInterval(() => {
            if (currentProgress < 95) {
                const maxStep = currentProgress > 70 ? 3 : 8;
                const step = Math.floor(Math.random() * maxStep) + 2;
                currentProgress = Math.min(95, currentProgress + step);
                $('#preloader_percentage').text(currentProgress + '%');
                $('#preloader_bar_progress').css('width', currentProgress + '%');
            }
        }, 80);
    }

    /**
     * Seamlessly hides the main preloader overlay with animations
     */
    private hideMainPreloader(): void {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }

        // Set to 100% immediately to confirm success
        $('#preloader_percentage').text('100%');
        $('#preloader_bar_progress').css('width', '100%');

        // Smooth fade out
        setTimeout(() => {
            const preloader = $('#kt_app_main_preloader');
            preloader.css({
                'opacity': '0',
                'visibility': 'hidden'
            });
            
            // Clean up from DOM
            setTimeout(() => {
                preloader.remove();
            }, 400);
        }, 200);
    }

    /**
     * Loads the target page content via AJAX partial request
     */
    private loadPage(url: string, pushState = true): void {
        const self = this;

        // Turn on the preloaders
        if (typeof matPreloader === 'function') {
            matPreloader('on');
        }
        self.showMainPreloader();

        $.ajax({
            url: url,
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-Partial': 'true'
            },
            success: function (html) {
                // Update container HTML
                $(self.containerSelector).html(html);

                // Scroll smoothly to top
                window.scrollTo({ top: 0, behavior: 'smooth' });

                // Push new state to history if requested
                if (pushState) {
                    history.pushState(null, '', url);
                }

                // Highlight active menu in sidebar
                self.highlightActiveMenu();

                // Re-initialize all dynamic components, DataTables, and datepickers
                if (typeof (window as any).initializeActiveTables === 'function') {
                    (window as any).initializeActiveTables();
                }
                
                if (typeof (window as any).initializeTasks === 'function') {
                    (window as any).initializeTasks();
                }

                // Turn off preloaders
                if (typeof matPreloader === 'function') {
                    matPreloader('off');
                }
                self.hideMainPreloader();
            },
            error: function (xhr, status, error) {
                if (typeof matPreloader === 'function') {
                    matPreloader('off');
                }
                self.hideMainPreloader();

                console.error('SPA Navigation Error:', error);

                // Show standard modal error if Swal is available
                if (typeof Swal !== 'undefined') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de carga',
                        text: 'No se pudo cargar la sección solicitada. Por favor, intente nuevamente.',
                        confirmButtonText: 'Entendido'
                    });
                } else {
                    alert('Error de carga. Por favor intente nuevamente.');
                }
            }
        });
    }

    /**
     * Highlights the correct sidebar menu item according to location.pathname
     */
    private highlightActiveMenu(): void {
        const currentPath = window.location.pathname;

        $('.menu-link.menu-watsontic').each(function () {
            const href = $(this).attr('href');
            if (href === currentPath) {
                $(this).addClass('active');
                // Also expand parent menus if they exist
                $(this).closest('.menu-item').addClass('here show');
                $(this).closest('.menu-accordion').addClass('show');
            } else {
                $(this).removeClass('active');
            }
        });
     }

    /**
     * Smart Session Refresh Strategy
     * ─────────────────────────────────
     * Token lifecycle:
     *   • Login token:    15 minutes
     *   • Refreshed token: 7 days
     *
     * The backend (ApiClient.php) already auto-refreshes expired tokens
     * on every API call (status 303 → silent refresh → retry).
     *
     * The frontend only needs to:
     *   1. Pre-emptively refresh BEFORE the token expires (so the user
     *      never hits a 303 on their next action)
     *   2. Detect a fully dead session (refresh_token also expired)
     *      and redirect to login
     *
     * Strategy:
     *   • On page load, schedule a single refresh at ~80% of token lifetime
     *   • After refresh, schedule the next one based on the NEW token's expiry
     *   • If the user is idle (tab hidden), skip and retry when they return
     */
    private refreshTimer: any = null;

    private startSmartSessionRefresh(): void {
        if (!window.location.pathname.startsWith('/admin')) {
            return;
        }

        // Schedule the first refresh based on the initial 15-min token
        // Refresh at ~12 minutes (80% of 15 min) to have a safety margin
        this.scheduleNextRefresh(12 * 60 * 1000);

        // Also refresh immediately when user returns to an inactive tab
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && !this.refreshTimer) {
                console.log('[SessionRefresh] Tab became visible, checking session...');
                this.executeRefresh();
            }
        });
    }

    private scheduleNextRefresh(delayMs: number): void {
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer);
        }

        console.log(`[SessionRefresh] Next refresh scheduled in ${Math.round(delayMs / 60000)} minutes.`);

        this.refreshTimer = setTimeout(() => {
            this.refreshTimer = null;

            // Only refresh if the tab is visible (user is active)
            if (document.visibilityState === 'hidden') {
                console.log('[SessionRefresh] Tab hidden, deferring refresh until tab is active.');
                return; // Will be triggered by visibilitychange listener
            }

            this.executeRefresh();
        }, delayMs);
    }

    private executeRefresh(): void {
        console.log('[SessionRefresh] Executing token refresh...');
        $.ajax({
            url: '/admin/auth/refresh',
            method: 'POST',
            dataType: 'json',
            success: (response: any) => {
                if (response.status === 200) {
                    console.log('[SessionRefresh] Token renewed successfully (new token valid for ~7 days).');

                    // After first refresh, token is valid for 7 days
                    // Schedule next refresh at ~6 days (safety margin)
                    const sixDays = 6 * 24 * 60 * 60 * 1000;
                    this.scheduleNextRefresh(sixDays);
                } else if (response.status === 401) {
                    console.warn('[SessionRefresh] Session expired completely. Redirecting to login...');
                    window.location.href = '/login';
                }
            },
            error: (xhr: any) => {
                if (xhr.status === 401) {
                    console.warn('[SessionRefresh] Unauthorized. Redirecting to login...');
                    window.location.href = '/login';
                } else {
                    // Network error or server issue — retry in 2 minutes
                    console.error('[SessionRefresh] Refresh failed, retrying in 2 minutes.');
                    this.scheduleNextRefresh(2 * 60 * 1000);
                }
            }
        });
    }
}

// Instantiate the SPA navigation system on document ready
$(document).ready(() => {
    (window as any).spaNavigation = new SPANavigation();
});
